import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon";
import { ToggleTile } from "@ui/components/ToggleTile";
import { INFLUENCE_FILTERS } from "../constants";

export interface InfluenceFiltersProps {
  onToggle: (value: string) => void;
  selected: string[];
}

export function InfluenceFilters({ onToggle, selected }: InfluenceFiltersProps) {
  const selectedSet = new Set(selected);

  return (
    <div className="grid grid-cols-2 gap-4">
      {INFLUENCE_FILTERS.map((filter) => (
        <ToggleTile
          color={filter.color}
          icon={<Icon color={filter.color} name="lightbulb" type="sticker" />}
          isSelected={selectedSet.has(filter.value)}
          key={filter.value}
          label={t(filter.labelKey)}
          onChange={() => onToggle(filter.value)}
          orientation="horizontal"
        />
      ))}
    </div>
  );
}
